import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { searchCategoryServices } from "../services/searchCategoryServices";

export const fetchCategories = createAsyncThunk(
  "categories/fetchCategories",
  async (params, { rejectWithValue }) => {
    try {
      let lang, parent_id;
      if (typeof params === "object") {
        lang = params.lang;
        parent_id = params.parent_id || null;
      } else {
        lang = params;
      }
      const response = await searchCategoryServices(lang, parent_id);
      return response.data.data.records;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  categories: [],
  childCategories: [],
  loading: false,
  error: null,
};

const searchCategorySlice = createSlice({
  name: "categories",
  initialState,
  reducers: {
    // 🧹 Clears child categories (used before fetching new ones)
    clearChildCategories: (state) => {
      state.childCategories = [];
    },

    // 🧩 Allows manually setting child categories (used when no deeper ones found)
    setChildCategories: (state, action) => {
      state.childCategories = action.payload || [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.loading = false;
        const { parent_id } = action.meta.arg || {};

        if (!parent_id) {
          // Top-level fetch
          state.categories = action.payload;
          state.childCategories = []; // reset
        } else {
          // Replace existing children with the next-level categories
          state.childCategories = action.payload || [];
        }
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearChildCategories, setChildCategories } =
  searchCategorySlice.actions;

export default searchCategorySlice.reducer;
